import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { sqlFormat } from './sqlFormat.js';
import { xmlFormat } from './xmlFormat.js';
import { sqlSafeFormat } from './sqlSafeFormat.js';
import '../helpers/types.js';

var QueryBuilderFormat = function QueryBuilderFormat() {
  var _this = this;

  _classCallCheck(this, QueryBuilderFormat);

  _defineProperty(this, "format", {
    defaultFormat: function defaultFormat(query) {
      return query;
    },
    sqlFormat: sqlFormat,
    xmlFormat: xmlFormat,
    sqlSafeFormat: sqlSafeFormat
  });

  _defineProperty(this, "currentFormat", 'sqlFormat');

  _defineProperty(this, "setDefaultFormat", function (formatName) {
    if (_this.format[formatName]) _this.currentFormat = formatName;
  });

  _defineProperty(this, "addFormat", function (formatName, format) {
    return _this.format[formatName] = format;
  });

  _defineProperty(this, "run", function (query, formatName) {
    if (_this.format[formatName]) return _this.format[formatName](query);
    return _this.format[_this.currentFormat](query);
  });
};

var QueryBuilderFormat$1 = new QueryBuilderFormat();

export default QueryBuilderFormat$1;
//# sourceMappingURL=format.js.map
